import { BusinessProfileRequest, BusinessProfileResponse } from '@oy/types';
import axios, { AUTH_PREFIX, AUTH_PREFIX_V2 } from 'src/clients/axios';

export const updateBusinessProfile = (data: BusinessProfileRequest) => {
  return axios.post(`${AUTH_PREFIX}/account/business-profile`, data);
};

export const updateBusinessProfileV2 = (data: BusinessProfileRequest) => {
  return axios.post(`${AUTH_PREFIX_V2}/account/business-profile`, data);
};

export const getBusinessProfile = () => {
  return axios.get<BusinessProfileResponse>(
    `${AUTH_PREFIX}/account/business-profile`,
  );
};
